'use client';

import { useState } from 'react';
import Image from 'next/image';
import type { DiningItemImageRecipe } from '../assets';

export default function DiningItemPhoto({ recipe, large = false, captionId }: { recipe: DiningItemImageRecipe; large?: boolean; captionId?: string }) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (!recipe.src) return null;
  const width = large ? 112 : 76;
  const caption = failed ? 'Photo unavailable' : recipe.kind === 'provider' ? loaded ? 'Menu photo' : 'Loading photo' : 'Illustrative photo';
  const sizeClass = large ? 'h-28 w-28' : 'h-[76px] w-[76px]';

  return <span className={`block shrink-0 text-xs ${large ? 'w-28' : 'w-[max(76px,6.5em)]'}`}>
    <span className={`relative block overflow-hidden rounded-control bg-[var(--ss-surface-subtle)] ${sizeClass}`}>
      {failed ? <span aria-hidden="true" className="flex h-full items-center justify-center text-[var(--ss-text-muted)]">—</span> : recipe.kind === 'provider'
        // Source photos are fetched directly; the Next image optimizer is not a
        // general remote-image proxy and its hostname permissions stay bounded.
        // eslint-disable-next-line @next/next/no-img-element
        ? <img src={recipe.src} alt="" width={width} height={width} loading="lazy" referrerPolicy="no-referrer" onLoad={() => setLoaded(true)} onError={() => setFailed(true)} className="h-full w-full object-cover" />
        : <Image src={recipe.src} alt="" fill sizes={`${width}px`} onLoad={() => setLoaded(true)} onError={() => setFailed(true)} className="object-cover" />}
    </span>
    <span id={captionId} className="mt-1 block text-xs leading-4 text-[var(--ss-text-muted)]">{caption}{!failed && recipe.kind === 'illustrative' ? <span className="sr-only">. Actual dish may differ.</span> : null}</span>
  </span>;
}
